import { toast } from "react-toastify";
import React, { useEffect, useState, useRef } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { Tab, Tabs } from "react-bootstrap";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { CnpjMask, OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { FileController } from "@/app/core/base/controllers/FileController";
import Field from "@/app/core/layouts/main-components/input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import ComplainModal from "@/app/core/layouts/main-components/complain/ComplainModal";
import { CompanyHelper } from "@/app/core/util/helpers/CompanyHelper";

export default function AdminCompanyModal({ show, onHide, company }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});
  const [complains, setComplains] = useState([]);
  const [selected, setSelected] = useState({});

  const inputFile = useRef(null);

  useEffect(() => {
    if (show && company && company.id) {
      setData(company);
      loadInfos();
    } else {
      setData({});
    }
  }, [show]);

  async function loadInfos() {
    let res = await ComplainController.ListByCompany(company.id);
    console.log("B.O.", res);
    for(let s of res){
      if(s !== undefined && s.userId !== undefined){
        const response = await AccountController.GetUser(s.userId);
        if(response != null && response.length > 0){
          s.user = response[0];
          s.company = company;
        }
      }
  }
    setComplains(res);
  }

  function onUploadClick() {
    inputFile.current.click();
  }

  async function save() {
    if (
      !data.name ||
      !data.email ||
      !data.taxId
    ) {
      toast.error(Message.PendingData);
      return;
    }
    if (data.id) {
      await CompanyController.Update(data);
    } else {
      await CompanyController.Insert(data);
    }
    toast.success(Message.Saved);
    onHide()
  }

  async function changeCompanyStatus(evt) {
    let old = data;
    old.verified = evt.target.value == "true" ? true : false;

    console.log("Itens ", evt.target.value, old.verified);

    await CompanyController.Update(old);
    toast.success(Message.Saved);
    setData(old);
  }

  function handleChange(evt, type) {
    setData(OnDataChange(data, evt, type))
  }

  async function uploadFile(files) {
    FileController.Upload(`company/${company.id}/logo`, files[0], async (res) => {
      let oldData = data;
      oldData.logo = res;
      setData(oldData);
      await CompanyController.Update(oldData);
      toast.success(Message.Saved);
    })
  }

  return (
    <Modal
      title="Empresa"
      show={show}
      onHide={onHide}
      isLoading={loading}
      onSubmit={() => save()}
    >
      {data && data.id ?
        <div className="block-content block-content-full text-center bg-body-light">
          <img
            className="img-avatar img-avatar-thumb img-link"
            onClick={(evt) => onUploadClick()}
            src={
              data && data.logo ? data.logo : "assets/media/avatars/avatar14.jpg"
            }
          />
          <div className="mt-2">
            <p className="font-w600 mb-0">{data && data.name}</p>
          </div>
        </div>
        : ""}
      <Tabs
        defaultActiveKey="resumo"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="resumo" title="Resumo" className="block-content">
          <Field title={"Nome"} name="name" value={data && data.name} onChange={evt => handleChange(evt)} type={FieldTypeObj.Text} />
          <Field title={"Email"} name="email" value={data && data.email} onChange={evt => handleChange(evt)} type={FieldTypeObj.Text} />
          <Field title={"Telefone"} name="phone" value={data && data.phone} onChange={evt => handleChange(evt)} type={FieldTypeObj.Mask} mask={"(99) 99999-9999"} />
          <Field title={"CNPJ"} name="taxId" value={data && data.taxId} onChange={evt => handleChange(evt)} type={FieldTypeObj.Mask} mask={"99.999.999/9999-99"} />
          <Field title={"Status"} name="status" options={CompanyHelper.StatusList} keyOption={"value"} nameOption={"name"} value={data && data.status} onChange={evt => handleChange(evt, FieldTypeObj.Number)} type={FieldTypeObj.Select} />
          <div className="form-group">
            <span>Endereço</span>
            <p>
              {data.city} - {data.state}
            </p>
          </div>

          <div className="form-group">
            <span>Nível de acesso</span>
            <select className="form-control" name="level" onChange={evt => changeCompanyStatus(evt)}>
              <option value={true} selected={data && data.verified === true ? true : false}>Verificada</option>
              <option value={false} selected={data && data.verified === false ? true : false}>Não Verificada</option>
            </select>
          </div>
        </Tab>
        {data && data.id ?
          <Tab
            eventKey="anuncios"
            title={complains && `(${complains.length}) Reclamações`}>
            <div className="list-group font-size-sm">
              {complains && complains.map(item => (
                <a className="list-group-item list-group-item-action" href="javascript:void(0)" onClick={() => setSelected(item) | setShowModal(true)}>
                  <p className="font-size-h6 font-w700 mb-0">
                    {item.title}
                  </p>
                  <p className="text-muted mb-2">
                    {item.description}
                  </p>
                </a>
              ))}
            </div>
          </Tab>
          : ""}
      </Tabs>

      <input
        type="file"
        ref={inputFile}
        onChange={(event) => {
          uploadFile(event.currentTarget.files);
        }}
        style={{ visibility: "hidden", width: 10 }}
      />
      
      <ComplainModal
        show={showModal}
        onHide={()=> setShowModal(false) | loadInfos()}
        infos={selected && selected}/>
    </Modal>
  );
}
